export const APP_TOKEN_KEY = "App-Token";



// WEBPACK FOOTER //
// ./src/modules/user/user-constants.js